export default __webpack_public_path__ + "static/media/Def Logo.ed07b222.png";